import { generateStoreCode } from "~/modules/i18n-extend/helpers";
import { AllowedLocales, AllowedStores } from "~/types/i18n";

export const BLOG_SORT_OPTIONS = [
  {
    id: "newest",
    title: "Newest first",
    option: "createdAt:DESC",
  },
  {
    id: "oldest",
    title: "Oldest first",
    option: "createdAt:ASC",
  },
];

export const BLOG_PAGE_SIZE = 20;

export const POST_TERM_INJECT_TOKEN = "postTitleHighlight";

export const ALL_BLOGS_PAGE_DESCRIPTION = {
  [generateStoreCode(AllowedStores.ee, AllowedLocales.et)]:
    "Pakendikeskuse blogist leiad kasulikke nõuandeid ja põnevaid uudiseid meie tegemistest",
  [generateStoreCode(AllowedStores.ee, AllowedLocales.en)]:
    "You can find useful advice and news about our activities in the Pakendikeskus blog",
  [generateStoreCode(AllowedStores.ee, AllowedLocales.ru)]:
    "Полезные советы и интересные новости о нашей деятельности вы найдете в блоге Pakendikeskus",
  [generateStoreCode(AllowedStores.fi, AllowedLocales.fi)]:
    "Packforce-blogista löydät hyödyllisiä neuvoja ja uutisia toiminnastamme",
  [generateStoreCode(AllowedStores.fi, AllowedLocales.en)]:
    "You can find useful advice and news about our activities in the Packforce blog",
  [generateStoreCode(AllowedStores.lv, AllowedLocales.lv)]:
    "Packforce emuārā varat atrast noderīgus padomus un aizraujošas ziņas par mūsu aktivitātēm",
  [generateStoreCode(AllowedStores.lv, AllowedLocales.en)]:
    "You can find useful advice and exciting news about our activities in the Packforce blog",
  [generateStoreCode(AllowedStores.lv, AllowedLocales.ru)]:
    "Полезные советы и интересные новости о нашей деятельности вы можете найти в блоге Packforce",
  [generateStoreCode(AllowedStores.lt, AllowedLocales.lt)]:
    "Naudingų patarimų ir naujienų apie mūsų veiklą rasite Packforce tinklaraštyje",
  [generateStoreCode(AllowedStores.lv, AllowedLocales.en)]:
    "You can find useful advice and news about our activities in the Packforce blog",
  [generateStoreCode(AllowedStores.lv, AllowedLocales.ru)]:
    "Полезные советы и новости о нашей деятельности вы можете найти в блоге Packforce",
};
